import FlexPane from './_flex-pane.js'
import PayoutInfo from './_payout-info.js'
import PrewagerPayoutInfo from './_prewager-payout-info.js'
import TaxInfo from './_tax-info.js'

export default {
  name: 'TotalPayoutInfo',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    payout: {
      configSet: PayoutInfo,
      configValues: {},
    },
    prewager: {
      configSet: PrewagerPayoutInfo,
      configValues: {},
    },
    tax: {
      configSet: TaxInfo,
      configValues: {},
    },
    payoutAfterTax: {
      configSet: PayoutInfo,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
